var React = require('react');

function Ee (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#333","d":"M0 167l254.6-36.6L512 166.9v178l-254.6 36.4L0 344.9z","key":0}),React.createElement("path",{"fill":"#0052b4","d":"M0 0h512v166.9H0z","key":1}),React.createElement("path",{"fill":"#eee","d":"M0 344.9h512V512H0z","key":2})])]);
}

Ee.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Ee;

Ee.default = Ee;
